import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-progress-steps',
  templateUrl: './progress-steps.component.html',
  styleUrls: ['./progress-steps.component.scss']
})
export class ProgressStepsComponent implements OnChanges {

  @Input() protected stepsNumber: number;
  @Input() protected currentStep: number;
  @Input() protected barColor: string = 'bg-success';

  protected steps: number[];
  protected remain: number;

  ngOnChanges() {
    this.remain = this.currentStep%1;
    this.currentStep = Math.floor(this.currentStep);
    this.steps = Array(this.stepsNumber - 1).fill(0).map((x, i) => i + 1);
  }

}
